export default __webpack_public_path__ + "static/media/Rectangle1.96f98549.jpg";